import axios from "axios";
import { authorizedHeader } from "./authorization";
import {
  companiesListUrl,
  companyCategoriesUrl,
  companyDateRangeUrl,
  companyReviewsUrl,
  companySubCategoriesUrl,
} from "components/Common/endpoints";

export const getCompanies = async () => {
  const response = await axios({
    method: "GET",
    url: companiesListUrl,
    params: {},
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};

export const getCompanyDateRange = async (company, start_date, end_date) => {
  const response = await axios({
    method: "GET",
    url: companyDateRangeUrl,
    params: {
      company,
      start_date,
      end_date,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};

export const getCompanyReviews = async (company, start_date, end_date, page_number, pagination_size, source_list, bike_model, sentiment, category, subCategory) => {
  const response = await axios({
    method: "POST",
    url: companyReviewsUrl,
    data: {
      company,
      start_date,
      end_date,
      page_number,
      pagination_size,
      source_list,
      bike_model,
      sentiment,
      categories: category ? [category] : null,
      sub_categories: subCategory ? [subCategory] : null
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};

export const getCompanyCategoryUrl = async (company, start_date, end_date, source, bike_model, sentiment) => {
  const response = await axios({
    method: "POST",
    url: companyCategoriesUrl,
    data: {
      company,
      start_date,
      end_date,
      source,
      bike_model,
      sentiment,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};

export const getCompanySubCategoryUrl = async (company, start_date, end_date, source, bike_model, sentiment, category) => {
  const response = await axios({
    method: "POST",
    url: companySubCategoriesUrl,
    data: {
      company,
      start_date,
      end_date,
      source,
      bike_model,
      sentiment,
      categories: category ? [category] : null,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};